import Vue from 'vue'
import IconBase from './components/icons/IconBase.vue'
import IconArrowLeft from './components/icons/IconArrowLeft.vue'
import IconArrowRight from './components/icons/IconArrowRight.vue'
import IconArrowUp from './components/icons/IconArrowUp.vue'
import IconCheck from './components/icons/IconCheck.vue'
import IconSearch from './components/icons/IconSearch.vue'
import IconSettings from './components/icons/IconSettings.vue'
import IconTriangleUp from './components/icons/IconTriangleUp.vue'
import IconTriangleDown from './components/icons/IconTriangleDown.vue'
import IconControls from './components/icons/IconControls.vue'
import IconClose from './components/icons/IconClose.vue'
import IconInfo from './components/icons/IconInfo.vue'
import IconFavorite from './components/icons/IconFavorite.vue'
import IconShare from './components/icons/IconShare.vue'
import IconGlobe from './components/icons/IconGlobe.vue'
import IconExternalLink from './components/icons/IconExternalLink.vue'
import IconDriveTo from './components/icons/IconDriveTo.vue'
import IconPhone from './components/icons/IconPhone.vue'
import IconMail from './components/icons/IconMail.vue'
import IconAddress from './components/icons/IconAddress.vue'
import IconNavigation from './components/icons/IconNavigation.vue'
import IconNahSh from './components/icons/IconNahSh.vue'
import IconPin from './components/icons/IconPin.vue'
import IconDistance from './components/icons/IconDistance.vue'
import IconResetInput from './components/icons/IconResetInput.vue'
import IconCrossHairs from './components/icons/IconCrossHairs.vue'
import IconSignLanguage from './components/icons/IconSignLanguage.vue'
import IconEasyLanguage from './components/icons/IconEasyLanguage.vue'
import IconLivingImages from './components/icons/IconLivingImages.vue'
import IconResetSettings from './components/icons/IconResetSettings.vue'
import IconWarning from './components/icons/IconWarning.vue'
import IconError from './components/icons/IconError.vue'
import IconDownload from './components/icons/IconDownload.vue'
import IconPrivacy from './components/icons/IconPrivacy.vue'
import Icon360 from './components/icons/Icon360.vue'
import IconAudioguide from './components/icons/IconAudioguide.vue'
import IconAugmentedReality from './components/icons/IconAugmentedReality.vue'
import IconChatbot from './components/icons/IconChatbot.vue'
import IconMultimedia from './components/icons/IconMultimedia.vue'
import IconVideo from './components/icons/IconVideo.vue'
import IconVirtualReality from './components/icons/IconVirtualReality.vue'

Vue.component('IconBase', IconBase)
Vue.component('IconArrowLeft', IconArrowLeft)
Vue.component('IconArrowRight', IconArrowRight)
Vue.component('IconArrowUp', IconArrowUp)
Vue.component('IconCheck', IconCheck)
Vue.component('IconSearch', IconSearch)
Vue.component('IconSettings', IconSettings)
Vue.component('IconTriangleUp', IconTriangleUp)
Vue.component('IconTriangleDown', IconTriangleDown)
Vue.component('IconControls', IconControls)
Vue.component('IconClose', IconClose)
Vue.component('IconInfo', IconInfo)
Vue.component('IconFavorite', IconFavorite)
Vue.component('IconShare', IconShare)
Vue.component('IconGlobe', IconGlobe)
Vue.component('IconExternalLink', IconExternalLink)
Vue.component('IconDriveTo', IconDriveTo)
Vue.component('IconPhone', IconPhone)
Vue.component('IconMail', IconMail)
Vue.component('IconAddress', IconAddress)
Vue.component('IconNavigation', IconNavigation)
Vue.component('IconNahSh', IconNahSh)
Vue.component('IconPin', IconPin)
Vue.component('IconDistance', IconDistance)
Vue.component('IconResetInput', IconResetInput)
Vue.component('IconCrossHairs', IconCrossHairs)
Vue.component('IconSignLanguage', IconSignLanguage)
Vue.component('IconEasyLanguage', IconEasyLanguage)
Vue.component('IconLivingImages', IconLivingImages)
Vue.component('IconResetSettings', IconResetSettings)
Vue.component('IconWarning', IconWarning)
Vue.component('IconError', IconError)
Vue.component('IconDownload', IconDownload)
Vue.component('IconPrivacy', IconPrivacy)
Vue.component('Icon360', Icon360)
Vue.component('IconAudioguide', IconAudioguide)
Vue.component('IconAugmentedReality', IconAugmentedReality)
Vue.component('IconChatbot', IconChatbot)
Vue.component('IconMultimedia', IconMultimedia)
Vue.component('IconVideo', IconVideo)
Vue.component('IconVirtualReality', IconVirtualReality)
